import * as React from 'react'

import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'
import { ExecutionElement } from '../flow/ExecutionElement'
import { ElementLabel } from '../flow/ElementLabel'

import type * as Flows from '../../../shared/domain/flows/types.no-deps'
import { toFixedWithoutTrailingZeros } from '../../../shared/lib/number.no-deps'
import type { LoopPathIds } from '../../../shared/domain/flows/LoopPath.no-deps'

interface Props {
    deps: CommonDeps
    elementId: Flows.ElementId
    loopPathIds: LoopPathIds
    label: string
    validationMessages: string[]
    calculationValue: number
    decimalPlaces: number
    openOptions?: () => void
}

export class ElementCalculation extends React.Component<Props, {}> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    private tryRender = () => {
        const { elementId, label, validationMessages, openOptions } = this.props

        const dispalyValue = toFixedWithoutTrailingZeros(this.props.calculationValue, this.props.decimalPlaces)

        return (
            <ExecutionElement
                deps={this.props.deps}
                elementId={elementId}
                loopPathIds={this.props.loopPathIds}
                validationMessages={validationMessages}
            >
                <ElementLabel
                    required={false}
                    label={label}
                    validationMessages={validationMessages}
                    openOptions={openOptions}
                />
                <div className="AppCore__flow__ElementCalculation">
                    <div className="AppCore__flow__ElementCalculation__value">{dispalyValue}</div>
                </div>
            </ExecutionElement>
        )
    }
}
